export enum LeadProspect {
  RATING_HOT = "hot",
  RATING_WARM = "warm",
  RATING_COLD = "cold",
}
